export const Image = (init = {}) => {
    var _a, _b, _c, _d;
    return ({
        large: (_a = init.large) !== null && _a !== void 0 ? _a : '',
        small: (_b = init.small) !== null && _b !== void 0 ? _b : '',
        empty: (_c = init.empty) !== null && _c !== void 0 ? _c : false,
        isEmpty: (_d = init.isEmpty) !== null && _d !== void 0 ? _d : false,
        colorCode: init.colorCode,
    });
};
const fromAPI = (data) => {
    if (typeof data === 'string') {
        return Image({
            small: data,
            large: data,
        });
    }
    return Image({
        ...data,
    });
};
const defaultImage = Image();
export default {
    record: defaultImage,
    default: defaultImage,
    fromAPI,
};
/**
 * Turns a color code returned by core into an Modern Famly AvatarColor
 *
 * @param colorCode
 * @returns An AvatarColor or undefined
 */
export const colorCodeToAvatarColor = (colorCode) => {
    if (colorCode === undefined) {
        return undefined;
    }
    switch (true) {
        case colorCode < 15:
            return 'blue';
        case colorCode < 31:
            return 'light-blue';
        case colorCode < 47:
            return 'green';
        case colorCode < 63:
            return 'light-green';
        case colorCode < 79:
            return 'yellow';
        case colorCode < 95:
            return 'light-yellow';
        case colorCode < 111:
            return 'orange';
        case colorCode < 127:
            return 'light-orange';
        default:
            return undefined;
    }
};
